"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategoryMenuOptions = exports.getParentCategory = exports.isMainCategory = exports.templateOptions = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _reselect = require("reselect");

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _GoodSubTypeGroups = _interopRequireDefault(require("../constants/GoodSubTypeGroups"));

var _SystemPageSubTypes = _interopRequireDefault(require("../constants/SystemPageSubTypes"));

var _utils = require("./utils");

var _langUtils = require("./langUtils");

var getAll = function getAll() {
  return [{
    item: _GoodSubTypes.default.ALL,
    chevron: false
  }, {
    item: _GoodSubTypeGroups.default.TEMPLATES,
    chevron: true
  }, {
    item: _GoodSubTypes.default.CUSTOM_MODULE,
    chevron: true
  }];
};

var systemTemplateOptions = (0, _immutable.OrderedSet)([_SystemPageSubTypes.default.CONTENT_SEARCH_RESULTS, _SystemPageSubTypes.default.ERROR_PAGE, _SystemPageSubTypes.default.PASSWORD_PAGE, _SystemPageSubTypes.default.SUBSCRIPTION_PREFERENCES, _SystemPageSubTypes.default.UNSUBSCRIBE_CONFIRMATION, _SystemPageSubTypes.default.UNSUBSCRIBE_SIMPLE]);
var templateOptions = (0, _immutable.OrderedSet)([_GoodSubTypes.default.EMAIL_TEMPLATES, _GoodSubTypes.default.BLOG_TEMPLATES, _GoodSubTypes.default.LANDING_PAGES, _GoodSubTypes.default.SITE_PAGES, _GoodSubTypeGroups.default.SYSTEM_PAGE_TEMPLATES, _GoodSubTypes.default.PACKS]);
exports.templateOptions = templateOptions;
var getTemplateOptions = (0, _reselect.createSelector)([function () {
  return templateOptions;
}], function (options) {
  return (0, _utils.getAlphaSortedArrOfTextValPairsForSelect)(options, _langUtils.getCategoryOptionText).map(function (option) {
    if (option.value === _GoodSubTypeGroups.default.SYSTEM_PAGE_TEMPLATES) {
      return (0, _extends2.default)({}, option, {
        options: (0, _utils.getAlphaSortedArrOfTextValPairsForSelect)(systemTemplateOptions.toArray(), _langUtils.getCategoryOptionText)
      });
    }

    return option;
  });
});
var moduleOptions = (0, _immutable.OrderedSet)([_GoodSubTypes.default.CUSTOM_MODULE]);

var isMainCategory = function isMainCategory(categoryFilter) {
  return categoryFilter === _GoodSubTypeGroups.default.TEMPLATES || categoryFilter === _GoodSubTypes.default.CUSTOM_MODULE || categoryFilter === _GoodSubTypes.default.ALL;
};

exports.isMainCategory = isMainCategory;

var getParentCategory = function getParentCategory(categoryFilter) {
  if (templateOptions.has(categoryFilter) || systemTemplateOptions.has(categoryFilter)) {
    return _GoodSubTypeGroups.default.TEMPLATES;
  } else if (moduleOptions.has(categoryFilter)) {
    return _GoodSubTypes.default.CUSTOM_MODULE;
  }

  return null;
};

exports.getParentCategory = getParentCategory;

var getCategoryMenuOptions = function getCategoryMenuOptions(categoryFilter) {
  if (categoryFilter === _GoodSubTypes.default.ALL) {
    return getAll();
  } else if (categoryFilter === _GoodSubTypeGroups.default.TEMPLATES || templateOptions.has(categoryFilter) || systemTemplateOptions.has(categoryFilter)) {
    return {
      options: getTemplateOptions(),
      parent: _GoodSubTypeGroups.default.TEMPLATES
    };
  } else if (moduleOptions.has(categoryFilter)) {
    var moduleParent = _GoodSubTypes.default.CUSTOM_MODULE;
    return {
      options: moduleOptions.subtract([moduleParent]),
      parent: moduleParent
    };
  }

  return new _immutable.OrderedSet();
};

exports.getCategoryMenuOptions = getCategoryMenuOptions;